import { captureException } from '@sentry/nextjs'

import ErrorBoundary from '@components/ErrorBoundary'
import MetadataHead from '@components/MetadataHead'

import useAppQueryState from '@hooks/useAppQueryState'
import useRouterParams from '@hooks/useRouterParams'

import { useUnscoredCategoriesQuery } from '@queries/useUnscoredCategoriesQuery'

import { getCardByCategory } from '@utils/getCardByCategory'
import { getCardMetadata } from '@utils/getCardMetadata'

import UnscoredCard from './UnscoredCard/UnscoredCard'
import UnscoredCardError from './UnscoredCardError'
import UnscoredCardNotFound from './UnscoredCardNotFound'
import UnscoredCardSkeleton from './UnscoredCardSkeleton'

const UnscoredCardRoute = () => {
    const routerParams = useRouterParams()
    const { appQueryState } = useAppQueryState()

    const unscoredCardResponse = useUnscoredCategoriesQuery({
        select: selectData => {
            return getCardByCategory(selectData, {
                cardId: routerParams.cardId as string,
                category: appQueryState.categoryId!,
            })
        },
    })

    switch (true) {
        case unscoredCardResponse.isLoading:
            return <UnscoredCardSkeleton />
        case unscoredCardResponse.isSuccess &&
            unscoredCardResponse.data != null:
            return (
                <ErrorBoundary
                    fallback={<UnscoredCardError />}
                    onError={({ error }) => captureException(error)}
                >
                    <>
                        <MetadataHead
                            metadata={getCardMetadata(
                                unscoredCardResponse.data!
                            )}
                        />
                        <UnscoredCard
                            unscoredCard={unscoredCardResponse.data!}
                        />
                    </>
                </ErrorBoundary>
            )
        case unscoredCardResponse.isSuccess &&
            unscoredCardResponse.data == null:
            return (
                <>
                    <MetadataHead metadata={undefined} />
                    <UnscoredCardNotFound />
                </>
            )
        case unscoredCardResponse.isError:
        default:
            return (
                <>
                    <MetadataHead metadata={undefined} />
                    <UnscoredCardError />
                </>
            )
    }
}

export default UnscoredCardRoute
